import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function Datatable({
  rows,
  columns,
  getRowId,
  table_name,
  // onPaginationModelChange,
  // paginationModel,
  // rowCount,
  search,
  onSearchTermChange,
}) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <h4 style={{ paddingTop: "10px", fontWeight: "bold" }}>{table_name}</h4>
        {search && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // onPaginationModelChange(paginationModel);
            }}
          >
            <FormControl variant="standard">
              <InputLabel htmlFor="input-with-icon-adornment">
                Search
              </InputLabel>
              <Input
                onChange={(e) => onSearchTermChange(e.target.value)}
                id="input-with-icon-adornment"
                endAdornment={
                  <InputAdornment position="start">
                    <Tooltip title="Search">
                      <SearchIcon
                        sx={{ cursor: "pointer" }}
                        // onClick={() => onPaginationModelChange(paginationModel)}
                      />
                    </Tooltip>
                  </InputAdornment>
                }
              />
            </FormControl>
          </form>
        )}
      </Box>
      <div
        style={{
          paddingTop: "10px",
          overflowX: "scroll",
          // overflowY: "hidden",
          // marginRight: "15px",
        }}
      >
        <DataGrid
          sx={{
            height: rows.length > 0 ? "auto" : "150px",
            "& .MuiDataGrid-cell": {
              fontFamily: "monospace",
            },
          }}
          rows={rows ? rows : ""}
          disableRowSelectionOnClick
          columns={columns ? columns : ""}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          // paginationModel={paginationModel}
          // initialState={{
          //   pagination: {
          //     paginationModel: paginationModel,
          //   },
          // }}
          // onPaginationModelChange={onPaginationModelChange}
          // pageSizeOptions={[5, 10, 20]}
          checkboxSelection={false}
          getRowId={getRowId}
          // rowCount={rowCount}
          // paginationMode="server"
        />
      </div>
    </div>
  );
}
